import { normalize } from 'normalizr'
import { camelize } from 'humps'

import { handleSerializedResponse, jsonPost } from 'api'
import { getRequestHeaders } from 'grs/api'
import * as auth from '../auth'

export const saveCardData = (token, cardData, apiLanguageCode = 'EN') =>
    jsonPost(
        `${GRS_ACCOUNTS_SERVICE}/SaveCardData`,
        {
            LAZAccountCardDetail: {
                Id: cardData.Id || '-1',
                NickName: cardData.Name,
                Active: true,
                ...cardData,
            },
            Token: token,
            ISOLangCode: 'EN',
        },
        {
            'Accept-Language': apiLanguageCode,
        }
    )
        .then(response => normalize(response, auth.schemas.userSchema))
        .catch()

export const removeCreditCard = (creditCard, apiLanguageCode = 'EN') =>
    jsonPost(
        `${GRS_ACCOUNTS_SERVICE}/SaveCardData`,
        {
            LAZAccountCardDetail: {
                Id: creditCard.id,
                ccToken: '',
                ExpDate: '',
                CardType: '',
                CardLast4: '',
                Name: '',
                NickName: '',
                CardProcessor: '',
                Active: false,
            },
        },
        {
            'Accept-Language': apiLanguageCode,
        }
    )
        .then(response => normalize(response, auth.schemas.userSchema))
        .catch()

export const setDefaultCreditCard = (token, creditCard, apiLanguageCode = 'EN') =>
    jsonPost(
        `${GRS_ACCOUNTS_SERVICE}/SaveDefaultCardData`,
        {
            LAZAccountCardDetail: {
                Id: creditCard.id,
                Active: true,
            },
            Token: token,
        },
        {
            'Accept-Language': apiLanguageCode,
        }
    )
        .then(response => normalize(response, auth.schemas.userSchema))
        .catch(error => {
            throw new Error(error.message)
        })

export const getPseBanks = async () =>
    await jsonPost(`${GRS_RESERVATIONS_SERVICE}/GetMerchantPaymentBanks`, {}, getRequestHeaders())
        .then(handleSerializedResponse)
        .catch(error => {
            throw new Error(error.message)
        })
